export default __webpack_public_path__ + "static/media/admin-features_img.14b98994.jpg";